import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CadastrarFuncionarioLayer from "../components/CadastrarFuncionarioLayer";
import { useTranslation } from "../i18n/I18nContext";

const CadastrarFuncionarioPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("funcionario.breadcrumb.create")} />
      <CadastrarFuncionarioLayer />
    </MasterLayout>
  );
};

export default CadastrarFuncionarioPage;
